import '../js/src/project';
import '../js/src/art.manager';
import '../js/src/opacc.basket';
import '../js/src/te.directsearchsuggest';
import '../js/src/custom.navigation';
import '../js/src/vendor/script/opacc.form';
import '../js/src/vendor/script/opacc.media';
import '../js/src/vendor/script/opacc.general';
import '../js/src/vendor/script/opacc.favorite';
import '../js/src/vendor/script/opacc.verification';

// SCSS
import '../../../project.scss';
import '../js/vendor/splidejs/css/splide.min.css';
import '../js/vendor/material-icons/iconfont/material-icons.scss';

import '@scss/modules/initial.scss';

import TKModuleFactory from '@tk/utilities/tk.module.factory';
import TEMainnav from '@/components/te.mainnav';

export default class Initial extends TKModuleFactory {
    constructor() {
        super([{ name: 'te-mainnav', constructor: TEMainnav }]);
    }
}

new Initial();
